import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string, putObject: Request): Promise<Optional<void>> {
	const url = `${SERVICEBASEURL.BACKEND}/Nutrient/${id}`;
	return axios.put(url, putObject).toOptionalVoid();
}

export interface Request {
	unitId: string;
	isMacroNutrient: boolean;
	sortOrder: number;
	nutrientCategoryId: string;
	nameTranslations: {
		[key: string]: string;
	};
	shortNameTranslations: {
		[key: string]: string;
	};
}
